// extracted by mini-css-extract-plugin
export default {"encerrar":"Checkbox_encerrar__lrt1A"};